import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/crm/sales-order/{id}/cancel`。PREPARING／SHIPPING → CANCELLED。body：`updatedAt`。 */
export async function cancelSalesOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/sales-order/${id}/cancel`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
